<div ng-controller="configuratorController as ctrl">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>